import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function createPaste(payload) {
  const { data } = await api.post("/pastes", payload);
  return data;
}

export async function getPasteMeta(id) {
  const { data } = await api.get(`/pastes/${id}/meta`);
  return data;
}

export async function consumePaste(id) {
  const { data } = await api.post(`/pastes/${id}/consume`);
  return data;
}

export async function getStats() {
  const { data } = await api.get("/stats");
  return data;
}
